import React, { useState } from "react";
import AdminLayout from "../../LayoutWrapper/AdminLayout";
import { useTranslation } from "react-i18next";
import swal from "sweetalert";
import MapImg from "../../Images/Contact/map.jpg";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import "../../CSS/UserLogin/index.css";
import "../../CSS/Contact/modern.css";

const Contact = () => {
  const { t } = useTranslation();
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    await new Promise((resolve) => setTimeout(resolve, 600));
    swal({
      icon: "success",
      text: "Thank you! We will get back to you shortly.",
    });
    setFullName("");
    setEmail("");
    setPhone("");
    setMessage("");
    setIsSubmitting(false);
  };

  return (
    <AdminLayout>
      <div className="contact-page">
        <section className="contact-hero">
          <span className="contact-hero__blob contact-hero__blob--1" aria-hidden="true" />
          <div className="contact-hero__inner">
            <div className="contact-hero__content">
              <span className="contact-hero__badge">
                <HeadsetMicOutlinedIcon sx={{ fontSize: 18 }} />
                We&apos;re here to help
              </span>
              <h1 className="contact-hero__title">{t("page_title_contact")}</h1>
              <p className="contact-hero__text">{t("contact_para1")}</p>
              <div className="contact-hero__chips">
                <span className="contact-hero__chip">
                  <AccessTimeOutlinedIcon fontSize="small" />
                  24/7 Support
                </span>
                <span className="contact-hero__chip">
                  <EmailOutlinedIcon fontSize="small" />
                  Quick response
                </span>
              </div>
            </div>
            <div
              className="contact-hero__image"
              role="img"
              aria-label="Contact Comfort Trip"
            />
          </div>
        </section>

        <section className="contact-main">
          <div className="contact-main__inner">
            <div className="contact-card">
              <h2 className="contact-card__title">{t("get_in_touch")}</h2>
              <p className="contact-card__subtitle">
                Fill out the form and our team will reach out to you.
              </p>
              <form className="contact-form" onSubmit={handleSubmit} noValidate>
                <div className="user-login-field">
                  <label className="user-login-label" htmlFor="contact-name">
                    {t("form_fullName_text")}
                  </label>
                  <div className="user-login-input-wrap">
                    <PersonOutlineIcon className="user-login-input-icon" />
                    <input
                      id="contact-name"
                      className="user-login-input"
                      type="text"
                      placeholder={t("form_fullName_text")}
                      required
                      value={fullName}
                      onChange={(e) => setFullName(e.target.value)}
                    />
                  </div>
                </div>
                <div className="user-login-field">
                  <label className="user-login-label" htmlFor="contact-email">
                    {t("form_email_text")}
                  </label>
                  <div className="user-login-input-wrap">
                    <EmailOutlinedIcon className="user-login-input-icon" />
                    <input
                      id="contact-email"
                      className="user-login-input"
                      type="email"
                      placeholder={t("form_email_text")}
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </div>
                <div className="user-login-field">
                  <label className="user-login-label" htmlFor="contact-phone">
                    {t("form_mobile_text")}
                  </label>
                  <div className="user-login-input-wrap">
                    <PhoneOutlinedIcon className="user-login-input-icon" />
                    <input
                      id="contact-phone"
                      className="user-login-input"
                      type="tel"
                      placeholder={t("form_mobile_text")}
                      required
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                    />
                  </div>
                </div>
                <div className="user-login-field">
                  <label className="user-login-label" htmlFor="contact-message">
                    Message
                  </label>
                  <textarea
                    id="contact-message"
                    className="user-login-input"
                    rows={4}
                    placeholder={t("form_messege_text")}
                    required
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  />
                </div>
                <button
                  type="submit"
                  className="contact-form__submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <span className="user-login-submit-spinner" />
                  ) : (
                    <SendOutlinedIcon fontSize="small" />
                  )}
                  {isSubmitting ? "Sending…" : t("form_sbmtBtn")}
                </button>
              </form>
            </div>

            <div className="contact-card contact-map-card">
              <h2 className="contact-card__title">{t("get_directions")}</h2>
              <p className="contact-card__subtitle">
                Find us on the map below
              </p>
              <div className="contact-map-wrap">
                <img src={MapImg} alt="Comfort Trip location map" />
              </div>
              <div className="contact-map-note">
                <LocationOnOutlinedIcon />
                <p>
                  Visit our office or get directions using your preferred maps app.
                  For ride or driver inquiries, use the contact form.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </AdminLayout>
  );
};

export default Contact;
